import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';
import { MetaDataChoice } from 'types/api/envScales/MetaDataChoice';
import * as R from 'ramda';

type OptionValue = {
  value: string;
};

export type FormatChoice = {
  [key: number]: OptionValue[];
};

export function getInitialState(
  contentChoices: MetaDataChoice[] | undefined,
  formatChoices: CycleMetaDataValue[]
) {
  let choices: FormatChoice = {};

  if (!contentChoices) {
    return choices;
  }

  contentChoices.forEach((contentChoice, index) => {
    choices[contentChoice.id] = [];
  });

  formatChoices.forEach((formatChoice, index) => {
    if (choices[formatChoice.meta_data_choice_id]) {
      choices[formatChoice.meta_data_choice_id].push({
        value: formatChoice.value
      });
    }
  });

  return choices;
}

export function addValue(
  value: string,
  choiceId: number,
  metaDataValues: FormatChoice
) {
  let newMetaDataValues = R.clone(metaDataValues);

  const newItem: OptionValue = { value };
  newMetaDataValues[choiceId].push(newItem);

  return newMetaDataValues;
}

export function removeValue(
  value: string,
  choiceId: number,
  metaDataValues: FormatChoice
) {
  let newMetaDataValues = R.clone(metaDataValues);

  newMetaDataValues[choiceId] = newMetaDataValues[choiceId].filter(
    item => item.value !== value
  );

  return newMetaDataValues;
}
